interface EnvConfig {
  VITE_APP_ENV: string;
  VITE_GGMBH_BACKEND_URL: string;
  VITE_GMBH_BACKEND_URL: string;
  VITE_SENTRY_DSN: string;
  VITE_AWS_BRANCH: string;
  VITE_AWS_JOB_ID: string;
  VITE_AWS_BUILD_TIME: string;
}

class EnvironmentService {
  private static instance: EnvironmentService;
  private env: EnvConfig;

  private constructor() {
    this.env = {
      VITE_APP_ENV: import.meta.env.VITE_APP_ENV,
      VITE_GGMBH_BACKEND_URL: import.meta.env.VITE_GGMBH_BACKEND_URL,
      VITE_GMBH_BACKEND_URL: import.meta.env.VITE_GMBH_BACKEND_URL,
      VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
      VITE_AWS_BRANCH: import.meta.env.VITE_AWS_BRANCH,
      VITE_AWS_JOB_ID: import.meta.env.VITE_AWS_JOB_ID,
      VITE_AWS_BUILD_TIME: import.meta.env.VITE_AWS_BUILD_TIME,
    };
  }

  public static getInstance(): EnvironmentService {
    if (!EnvironmentService.instance) {
      EnvironmentService.instance = new EnvironmentService();
    }
    return EnvironmentService.instance;
  }

  public getEnv(): EnvConfig {
    return this.env;
  }

  public getValue(key: keyof EnvConfig): string {
    return this.env[key];
  }

  public isProduction(): boolean {
    return this.env.VITE_APP_ENV === "prod";
  }

  public isDevelopment(): boolean {
    return this.env.VITE_APP_ENV === "develop";
  }

  public isStaging(): boolean {
    return this.env.VITE_APP_ENV === "staging";
  }

  public isLocal(): boolean {
    return this.env.VITE_APP_ENV === "local";
  }

  public getCurrentBranch(): string {
    return this.env.VITE_AWS_BRANCH;
  }

  public getBuildJobId(): string {
    return this.env.VITE_AWS_JOB_ID;
  }

  public getBuildTime(): string {
    return this.env.VITE_AWS_BUILD_TIME;
  }
}

export const envService = EnvironmentService.getInstance();
